import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/system';

import { Card, CardHeader, CardContent, Avatar, ForgeIcon } from './ui';

const MessageContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: theme.spacing(1),
    [theme.breakpoints.down('lg')]: {
        marginLeft: 0,
        padding: theme.spacing(1),
    },
}));

const Dot = styled(Box)({
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: '#800000',
    animation: 'typingDots 1.5s infinite',
    '@keyframes typingDots': {
        '0%':   { opacity: 0.2, transform: 'translateY(0)' },
        '50%':  { opacity: 1,   transform: 'translateY(-6px)' },
        '100%': { opacity: 0.2, transform: 'translateY(0)' },
    },
});

const ChatLoading = ({ product }) => {
    return (
        <MessageContainer aria-live='polite'>
            <Card
                className="mt-6"
                sx={{
                    borderLeft: '4px solid #E20000',
                    boxShadow: '0 2px 16px rgba(51,0,0,0.08)',
                    borderRadius: '0 8px 8px 0',
                }}
            >
                <CardHeader
                    avatar={<Avatar icon={<ForgeIcon />} size="sm" />}
                    subtitle={`HelpBot • ${product || ''}`}
                    title="HelpBot"
                    titleVariant="default"
                    sx={{
                        borderBottom: '1px solid rgba(0,0,0,0.08)',
                        '& .MuiCardHeader-title': { fontWeight: 600, color: '#330000' },
                        '& .MuiCardHeader-subheader': { fontSize: '0.75rem' },
                    }}
                />
                <CardContent top="none">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1 }}>
                        <Dot style={{ animationDelay: '0s' }} />
                        <Dot style={{ animationDelay: '0.3s' }} />
                        <Dot style={{ animationDelay: '0.6s' }} />
                    </Box>
                </CardContent>
            </Card>
        </MessageContainer>
    );
};

export default ChatLoading;
